import React from "react";
import { Avatar, Chip, Muted } from "../../Components/DataTable";
import Address from "../../Components/BasicComponents/ProfileCardAddress";

const NOT_PROVIDED = <Muted>Not Provided</Muted>;

const teamChips = (teams) =>
  !teams || teams.length < 1 ? (
    NOT_PROVIDED
  ) : (
    <span style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
      {teams.map((team, i) => (
        <Chip key={i}>{team?.name}</Chip>
      ))}
    </span>
  );

const nameCell = (row) => (
  <span style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, fontWeight: 600 }}>
    <Avatar name={row?.name} url={row?.profilePhotoUrl} />
    <span style={{ minWidth: 0, wordBreak: "break-word" }}>{row?.name}</span>
  </span>
);

// Columns for the staff and client lists (same fields as before: Name, Email, Role/Address, Team).
export const peopleColumns = (type) => [
  { key: "name", header: "Name", width: "22%", primary: true, avatar: true, render: nameCell },
  { key: "email", header: "Email", width: "28%", render: (row) => row?.email },
  type === "staff"
    ? {
        key: "role",
        header: "Role",
        width: "25%",
        render: (row) => (row?.role ? <Chip>{row.role}</Chip> : NOT_PROVIDED),
      }
    : {
        key: "address",
        header: "Address",
        width: "25%",
        render: (row) => (row?.address ? <Address data={row.address} /> : NOT_PROVIDED),
      },
  { key: "teams", header: "Team", width: "25%", render: (row) => teamChips(row?.teams) },
];

// Mobile card: avatar, name, role chip (staff), email, address (client), teams.
export const renderPeopleCard = (type) => (row) => (
  <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
    <Avatar name={row?.name} url={row?.profilePhotoUrl} size={40} />
    <div style={{ minWidth: 0, flex: 1 }}>
      <div style={{ fontWeight: 700, wordBreak: "break-word" }}>{row?.name}</div>
      {type === "staff" && row?.role && (
        <div style={{ marginTop: 4 }}>
          <Chip>{row.role}</Chip>
        </div>
      )}
      <div style={{ marginTop: 4, wordBreak: "break-word" }}>{row?.email}</div>
      {type !== "staff" && (
        <div style={{ marginTop: 4 }}>
          {row?.address ? <Address data={row.address} /> : NOT_PROVIDED}
        </div>
      )}
      {row?.teams?.length > 0 && <div style={{ marginTop: 8 }}>{teamChips(row.teams)}</div>}
    </div>
  </div>
);
